<template>
   <vue-perfect-scrollbar class="scroll-area">
    <vs-tabs :key="refreshKey">
    <vs-progress
      indeterminate
      color="primary"
      v-if="isLoading == true"
    ></vs-progress>

    <vs-tab label="Trip Details" icon="dashboard" @click="colorx = '#8B0000'">
      <vx-card>
        <div class="vx-row">
          <vs-input
            label="Title"
            v-model="tripInfo.title"
            class="w-full mt-4"
          />
          <vs-input
            label="Invoice Id (Ref num)"
            v-model="tripInfo.invoiceId"
            class="w-full mt-4"
          />
          <label class="vs-input--label">Scheduled Start Date</label>
          <input
            type="date"
            v-model="tripInfo.scheduledStartDate"
            class="w-full mt-5"
          />

          <hr />

          <label class="vs-input--label">Transporter Type</label>
          <v-select
            :options="['IN HOUSE (OWN TRUCK)', 'TRANSPORTER']"
            v-model="tripInfo.transporterType"
            placeholder="Select Transporter Type"
            class="w-full mt-5"
          />

          <div v-if="tripInfo.transporterType == 'IN HOUSE (OWN TRUCK)'">
            <label class="vs-input--label">Assign Driver</label>
            <v-select
              :options="allDrivers"
              placeholder="Assign Driver for Trip"
              v-model="tripInfo.driverId"
              :clearable="false"
              value="id"
              label="id"
            >
              <template slot="option" slot-scope="option" class="w-full mt-5">
                {{
                  '(Driver Id:' +
                  option.id +
                  ') ' +
                  JSON.parse(option.driverInfo).fullName
                }}
              </template>
              <template
                slot="selected-option"
                slot-scope="option"
                class="w-full mt-5"
              >
                {{
                  '(Driver Id:' +
                  option.id +
                  ') ' +
                  JSON.parse(option.driverInfo).fullName
                }}
              </template>
            </v-select>
            <br />
            <label class="vs-input--label">Assign Truck</label>
            <v-select
              :options="unitSelection"
              placeholder="Assign Truck for Trip"
              v-model="tripInfo.assetId"
              :clearable="false"
              value="assetId"
              label="assetName"
            >
              <template slot="option" slot-scope="option" class="w-full mt-5">
                {{ option.assetName }}
              </template>
              <template
                slot="selected-option"
                slot-scope="option"
                class="w-full mt-5"
              >
                {{ option.assetName }}
              </template>
            </v-select>
          </div>

          <div v-if="tripInfo.transporterType == 'TRANSPORTER'">
            <label class="vs-input--label">Assign Transporter</label>
            <v-select
              :options="allTransporters"
              placeholder="Assign Driver for Trip"
              v-model="tripInfo.transporterId"
              :clearable="false"
              value="id"
              label="id"
            >
              <template slot="option" slot-scope="option" class="w-full mt-5">
                {{
                  '(TS Id:' + option.id + ') ' + JSON.parse(option.tpInfo).name
                }}
              </template>
              <template
                slot="selected-option"
                slot-scope="option"
                class="w-full mt-5"
              >
                {{
                  '(TS Id:' + option.id + ') ' + JSON.parse(option.tpInfo).name
                }}
              </template>
            </v-select>
            <br />
            <div v-if="tripInfo.transporterId != null">
              <label class="vs-input--label">Assign Truck</label>
              <v-select
                :options="tripInfo.transporterId.tpAssets"
                placeholder="Assign Driver for Trip"
                v-model="tripInfo.transporterAssetId"
                :clearable="false"
                value="plateNo"
                label="plateNo"
              >
                <template slot="option" slot-scope="option" class="w-full mt-5">
                  {{ option.plateNo }}
                </template>
                <template
                  slot="selected-option"
                  slot-scope="option"
                  class="w-full mt-5"
                >
                  {{ option.plateNo }}
                </template>
              </v-select>
              <br />
            </div>
          </div>
        </div>
        <br /><br />
        <vx-card
          :title="index + 1 + '. Location: ' + item.location.metadata.name"
          v-for="(item, index) in pickups"
          :key="index"
        >
          <li class="suggestion-group-suggestion cursor-pointer">
            <span
              ><b>{{
                'Client: ' + JSON.parse(item.clientInfo.clientInfo).name
              }}</b></span
            ><br />
            <span>{{
              'Invoice Num: ' + item.invoiceId + ' | PO Num: ' + item.poId
            }}</span
            ><br />
            <span v-if="item.date != null">{{
              'Start Date/Time: ' + item.date + ' ' + item.time
            }}</span
            ><br />
            <span>{{
              'Details: ' + item.goodsWeight + '  tonnes / ' + item.goodsType
            }}</span
            ><br />
            <span>{{
              'Deadline: ' + item.deadlineDate + ' | ' + item.deadlineTime
            }}</span
            ><br />
            <span>{{ 'Remarks: ' + item.remarks }}</span
            ><br />
            <span>
              <vs-button color="success" size="small" type="border"
                >NO ALERTS SO FAR</vs-button
              >&nbsp;</span
            >
            <span>
              <vs-button color="warning" size="small" type="border"
                >INCOMPLETE</vs-button
              >&nbsp;</span
            >
            <span>
              <vs-button color="primary" size="small" type="border"
                >E-SIGNATURE CONFIRMATION :
                {{ item.requireSignature }}</vs-button
              >&nbsp;</span
            >
          </li>
        </vx-card>

        <br />
        <div id="directions-panel"></div>
        <br /><br />

        <div id="map" ref="map"></div>
      </vx-card>
    </vs-tab>
    <vs-tab label="Alerts" icon="event" @click="colorx = '#8B0000'">
      <vx-card style="min-height: 500px">
        <table class="responsive">
          <tr>
            <th>No.</th>
            <th>Date Time.</th>
            <th>Location (*)</th>
            <th>Affected Client (if applicable)</th>
            <th>Remarks</th>
            <th>Actions</th>
          </tr>
        </table>
      </vx-card>
    </vs-tab>
    <vs-tab label="Playback" icon="event" @click="colorx = '#8B0000'">
      <vx-card style="min-height: 500px">
        <p>
          Actual Route Playback vs Suggested Route will be available after Trip
          is COMPLETED.
        </p>

        <br />
      </vx-card>
    </vs-tab>
  </vs-tabs>
  <br><br>
   </vue-perfect-scrollbar>

</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { Query, Predicate } from '@syncfusion/ej2-data';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vSelect from 'vue-select';
import moment from 'moment';
import { Loader } from '@googlemaps/js-api-loader';
import { getBaseURL } from '@/config.js';

export default {
  components: {
    FormWizard,
    TabContent,
    MultiSelectPlugin,
    Query,
    Predicate,
    vueDropzone: vue2Dropzone,
    vSelect,
    Loader,
    moment,
  },
  data() {
    return {
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      mapPOIData: JSON.parse(localStorage.getItem('mapPOIData')),
      geoPOIData: JSON.parse(localStorage.getItem('geoPOIData')),
      quickSelect: null,
      fleetConfig: null,
      popupActive: false,
      pickups: [],
      refreshKey: 0,
      isLoading: true,
      tripId: this.$route.params.tripId,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      allowCustomValue: true,
      loadingWizard: false,
      errorMsg: null,
      driverAlarm: [],
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      selectedUnit: null,
      tpEndpoints: [],
      tpNotifications: [],
      tripInfo: {
        transporterType: '',
        transporterAssets: [],
        pickups: [],
        groute: {},
      },
      allDrivers: [],
      allTransporters: [],
      allClients: [],
      industries2: [
        '1 Tonne',
        '2 Tonnes',
        '3 Tonnes',
        '5 Tonnes',
        '5 Tonnes (Box lorry)',
        '10 Tonnes (Loading Capability Of 8 Tonnes)',
        '15 Tonnes (Loading Capability Of 14 Tonnes)',
        '1 tonne',
        '3 / 5 tonne',
        '10 Tonne (Cargo Truck)',
        '10 Tonne Tipper / Crane - 1',
        '20 Tonne Tipper / Crane - 1',
        'Ready Mix',
        'Prime Movers - 1',
        'Prime Movers - 2',
      ],
      industries: [
        'Personal Usage',
        'Agriculture & Farm Product',
        'Construction',
        'Container Handling',
        'Container Haulage',
        'Courier',
        'Drilling Rig Machine',
        'Food Distribution',
        'General Cargo',
        'Manufacturing Raw Materials',
        'Milling Machine',
        'Palm Oil',
        'Pavers',
        'Petro Chemical Tankers',
        'Road Roller',
        'Skid Steer Roller',
        'Stacker',
        'Tractor',
        'Tractor Back Pusher',
        'Utility & Public Services',
      ],
      tripInfo: {
        assetId: -1,
        plate: null,
        type: '',
        subType: '',
        brand: '',
        model: '',
        industry: null,
        class: null,
        vehicleImages: [],
      },
      dropzoneOptions: {
        url: getBaseURL() + '/fleets/uploadFiles',
        thumbnailWidth: 150,
        maxFilesize: 10.0,
        maxFiles: 15,
        addRemoveLinks: true,
        //autoProcessQueue: false
      },
      loaded: false,
      isLoading: false,
      loader: null,
      map: null,
      streetMap: null,
      markerCluster: null,
      directionsService: null,
      directionsRenderer: null,
      directions: { start: '', end: '', waypoints: [] },
      total: { time: 0, distance: 0, reachTime: '' },
      refinedPOI: [],
      pickupTime: new Date(),
      groute: null,
    };
  },
  computed: {},
  methods: {
    calculateAndDisplayRoute() {
      const self = this;
      if (self.pickups.length < 2) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Select at least 2 points to begin a trip',
          color: 'warning',
        });
      }
      self.total = { time: 0, distance: 0, reachTime: '' };
      const waypts = [];

      const numOfPoints = self.pickups.length;
      let i = 0;
      self.pickups.forEach((place) => {
        if (i != 0 || i != numOfPoints - 1) {
          //        console.log(waypts)
          waypts.push({
            location: {
              lat: self.pickups[i].location.metadata.lat,
              lng: self.pickups[i].location.metadata.lng,
            },
            stopover: true,
          });
        } else {
          console.log('-');
        }
        i++;
      });

      self.directionsService.route(
        {
          origin: {
            lat: self.pickups[0].location.metadata.lat,
            lng: self.pickups[0].location.metadata.lng,
          },
          destination: {
            lat: self.pickups[numOfPoints - 1].location.metadata.lat,
            lng: self.pickups[numOfPoints - 1].location.metadata.lng,
          },
          waypoints: waypts,
          optimizeWaypoints: true,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (response, status) => {
          if (status === 'OK' && response) {
            self.directionsRenderer.setDirections(response);
            const route = response.routes[0];
            const summaryPanel = document.getElementById('directions-panel');
            summaryPanel.innerHTML = '';
            let i;
            // For each route, display summary information.
            for (let i = 0; i < route.legs.length; i++) {
              const routeSegment = i + 1;
              summaryPanel.innerHTML += `<b>Route Segment: ${routeSegment}</b><br>`;
              const startAddr = route.legs[i].start_address;
              const endAddr = route.legs[i].end_address;

              summaryPanel.innerHTML += `${startAddr} <b>to</b> `;
              summaryPanel.innerHTML += `${endAddr}<br>`;
              summaryPanel.innerHTML += `${route.legs[i].distance.text} / ${route.legs[i].duration.text} <br><br>`;
              self.total.time = self.total.time + route.legs[i].duration.value;
              //   console.log(route.legs[i].duration.value)
              self.total.distance =
                self.total.distance + route.legs[i].distance.value;

              if (i == route.legs.length - 1) {
                summaryPanel.innerHTML +=
                  `<b>Trip Summary - ${(self.total.distance / 1000).toFixed(
                    1,
                  )}km / ${moment
                    .utc(self.total.time * 1000)
                    .format('HH:mm')} hrs ` +
                  ` / ETA : ${moment(self.pickupTime)
                    .add(self.total.time, 's')
                    .format(
                      'DD/MM/YY HH:MM:ss',
                    )} based on current traffic conditions</b>`;
              }
            }
          } else {
            window.alert(`Directions request failed due to ${status}`);
          }
        },
      );
    },
    vehicleImagesUpload(files, response) {
      this.tripInfo.vehicleImages.push(response.path);
    },
    vehicleDocumentsUpload(files, response) {
      this.tripInfo.vehicleImages.push(response.path);
    },
    addRecord() {
      this.fleetMaintenance.push({
        type: '',
        subtype: '',
        date: '',
        documents: [],
        remark: 'Amount:- | PIC:- | Payment Status:- | Others:-',
      });
    },
    getTrips() {
      const self = this;

      self.$http
        .get(`tripsSingle/${self.tripId}`, {})
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.tripInfo = JSON.parse(response.data.tripDetails.tripInfo);

            self.pickups = self.tripInfo.pickups;
            self.groute = self.tripInfo.groute;
            self.calculateAndDisplayRoute();
            self.isLoading = false;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
  },
  created() {},
  watch: {},
  mounted() {
    const self = this;
    self.loader = new Loader(this.$loader);
    self.loader.load().then(() => {
      self.map = new google.maps.Map(self.$refs.map, {
        center: { lat: 3.910187, lng: 102.119262 },
        zoom: 8,
        gestureHandling: 'greedy',
      });
      self.directionsService = new google.maps.DirectionsService();
      self.directionsRenderer = new google.maps.DirectionsRenderer();
      self.directionsRenderer.setMap(self.map);

      const poi = self.mapPOIData.map((data, i) => {
        const poi = new google.maps.Polygon(data);

        google.maps.event.addListener(poi, 'click', function (event) {
          alert(data.metadata.name);
        });
        poi.setMap(self.map);

        return poi;
      });
      self.getTrips();
      self.isLoading = false;
    });
  },
};
</script>

<style lang="scss" scoped>
td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
#map {
  height: 70vh;
}
</style>
